import { createRoot } from 'react-dom/client';
import AppWrapper from './App';
import packageJson from '../package.json';
import { LicenseInfo } from '@mui/x-license-pro';


require('../node_modules/react-grid-layout/css/styles.css')
require('../node_modules/react-resizable/css/styles.css')

require('dashboard/dashboardStyles.css')

LicenseInfo.setLicenseKey(process.env.MUI_X_TOKEN);

window.crossfilters = {}
window.appVersion = packageJson.version;

const container = document.getElementById('root');
const root = createRoot(container); 
root.render(<AppWrapper />);
